import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
export default {
  namespaced: true,
  state: () => ({
    beginDate: new Date('2022-05-31T23:59:59'),

    paymentCard: null,
    liqpayButton: null,
    loading: false,
    error: null
  }),
  mutations: {
    setPaymentCard(state, payload) {
      // console.log('PC');
      // console.log(payload);
      state.paymentCard = payload
    },
    setLiqpayButton(state, payload) {
      state.liqpayButton = payload
      // console.log('LL');
      // console.log(payload);
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setError(state, payload) {
      state.error = payload
    },
    clearError(state) {
      state.error = null;
    },
  },
  actions: {
    
    async getPaymentCard({ dispatch, commit, state }, payload) {
      // console.log('AgreementDatastart');
      dispatch('setLoading', true)
      await axios
        .post('https://midas.ua/axios/get_payment_card.php',
          {
            paymentCard: payload.paymentCard
          })
        .then(response => {
          // console.log('AgreementData');
          // console.log(response);
          if (response.data.ErrorsData.AreErrors) {
            // Игнорируем ошибки
            // response.data.ErrorsData.Errors.forEach(element => {
            //   commit('setError', element)
            // });
            // Вместо ошибок и зсервиса пишем "неверный номер договора"
            commit('setError', 'Невірний номер договору')
            commit('setPaymentCard', null)
            dispatch('setLoading', false)

            return;
          }
          // console.log('response.data.AgreementData');
          // console.log(response.data.AgreementData);
          const docDate = new Date(response.data.AgreementData.AgreementDate);
          if (docDate<=state.beginDate) {
            commit('setError', 'Будь ласка зверніться у найближче відділення Мідас')
            commit('setPaymentCard', null)

          } else {
            commit('setPaymentCard', response.data.AgreementData)

          }

         
            // console.log('AgreementData');
            // console.log(response.data);
          
          
          // if (response.data == 'error') {
          //   commit('setError', 'Данный договор не найден')
          //   commit('setPaymentCard', null)
          // } 

          dispatch('setLoading', false)
        })
    },
    async getLiqpayButton({ dispatch, commit }, payload) {
      dispatch('setLoading', true)
      // console.log('amount' + payload.amount)
      await axios
        .post('https://midas.ua/axios/get_btn.php',
          {
            amount: payload.amount,
            description: payload.description,
            cardId: payload.cardId

          })
        .then(response => {
          // console.log('btn-response')
          // console.log(response);
          
          commit('setLiqpayButton', response.data)

          dispatch('setLoading', false)
        })
    },
    setLoading({ commit }, payload) {
      commit('setLoading', payload)
    },
    clearError({ commit }) {
      commit('clearError');
    },

  },
  getters: {
    returnPaymentCard(state) {
      return state.paymentCard
    },
    returnLiqpayButton(state) {
      return state.liqpayButton
    },
    returnError(state) {
      return state.error
    },
    // returnServiceRecord (state, rootGetters) {
    //   return state.serviceRecord
    // },
    // returnTotalRecord (state, rootGetters) {
    //   return state.totalRecord
    // },
    returnLoading(state) {
      return state.loading
    }
  }
}
